/**
 * HTML redaktoru boş olanda belə `<br>`, `<div><br></div>` və ya `&nbsp;`
 * qaytara bilər. Sadə `!value` yoxlaması bunu «dolu» sayır və boş yazının
 * saxlanmasına yol verirdi.
 */
export function isHtmlEmpty(html: string | undefined | null): boolean {
  if (!html) return true;

  const text = html
    .replace(/<[^>]*>/g, '')   // teqləri at
    .replace(/&nbsp;/gi, ' ')
    .trim();

  // mətn yoxdursa da şəkil varsa yazı boş sayılmır
  const hasMedia = /<img\b/i.test(html);

  return text.length === 0 && !hasMedia;
}
